import type { SessionPrincipal } from '@laspalmas-identity/shared';
import { Button } from './ui';
import { Icon } from './icons';
import { useI18n } from '../lib/i18n';

export function ImpersonationBanner({ principal, onEnd }: { principal: SessionPrincipal; onEnd: () => void | Promise<void> }) {
  const { t, locale } = useI18n();
  if (!principal.impersonationId) return null;
  const expires = principal.impersonationExpiresAt ? new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(new Date(principal.impersonationExpiresAt)) : t('soon');
  return <div className="impersonation-banner" role="alert">
    <Icon name="eye"/>
    <p><strong>{t('impersonating')}</strong><span>{t('impersonationReason', { reason: principal.impersonationReason ?? t('reasonNotProvided'), time: expires })}</span></p>
    <Button variant="secondary" size="small" onClick={() => void onEnd()}>{t('endImpersonation')}</Button>
  </div>;
}
